import { atom } from "jotai";

export const rendimientoAtom = atom([]);
export const loadingAtom = atom(false);
export const dnisNoProcesadosAtom = atom([]);
